<template>
  <div class="h-full pr-20px">
    <div class="w-full h-full overflow-auto">
      <iframe class="w-full h-full" :src="iframeSrc" frameborder="0"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'collectionManage',
  data() {
    return {
      iframeSrc: '',
    }
  },
  created() {
    const currentEnv = Wiz.GetModuleConfig('legacy-resource').currentEnv
    this.iframeSrc = `${currentEnv.VUE_APP_KETTLE_PAGE}/index`
  },
}
</script>
